<template>
  <div>
    <v-row class="text-center mt-2">
      <h3>{{ topic }}</h3>
    </v-row>
    <br /><br />
    <v-row class="text-center">
      <br />
      <v-icon>mdi-access-point</v-icon>&nbsp; Live Session <br />
    </v-row>

    <v-row class="text-center">
      <v-col class="mx-3">
        <v-btn
          @click="linkOpen(yt)"
          color="error"
          :disabled="yt.length == 0"
          depressed
          outlined
          v-if="statusx == 'done'"
        >
          REWATCH via Youtube</v-btn
        >
        <v-btn
          v-if="statusx == 'upcoming'"
          @click="linkOpen(yt)"
          color="error"
          :disabled="yt.length == 0"
          depressed
          outlined
        >
          WATCH via Youtube</v-btn
        >
      </v-col>
      <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
      <v-col class="mx-3">
        <v-btn
          @click="linkOpen(zm)"
          color="primary"
          :disabled="zm.length == 0"
          depressed
          >Join via Zoom</v-btn
        >
      </v-col>
    </v-row>
    <!-- <v-row> {{ soln }} Test </v-row> -->

    <v-row v-if="project.length != 0">
      <v-icon>mdi-clipboard-arrow-down</v-icon>&nbsp; Projects/Assignments
    </v-row>
    <v-row class="text-center" v-if="project.length != 0">
      <v-col>
        <v-btn
          @click="linkOpen(project)"
          color="error"
          depressed
          :disabled="project.length == 0"
        >
          {{ end_date }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="soln.length != 0">
      <br />
      <v-icon>mdi-creation</v-icon>&nbsp; Solution <br />
    </v-row>
    <v-row class="text-center" v-if="soln.length != 0">
      <v-col>
        <v-btn
          @click="linkOpen(soln)"
          color="success"
          depressed
          :disabled="soln.length == 0"
        >
          SOLUTION FOR THE ASSIGNMENT
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="req == 'yy'">
      <v-icon>mdi-hammer-wrench</v-icon>&nbsp; Materials Required
    </v-row>
    <br />
    <v-row class="text-center" v-if="req == 'yy'">
      <v-col>
        <span v-for="(item, i) in materials" :key="i"> {{ item }}, </span>
      </v-col>
    </v-row>
    <v-row v-if="readings.length != 0"
      ><v-icon>mdi-book-open</v-icon>&nbsp; Readings for Session</v-row
    >
    <v-row class="text-center" v-if="readings.length != 0">
      <v-col>
        <v-btn
          @click="linkOpen(readings)"
          color="lime lighten-4"
          depressed
          :disabled="readings.length == 0"
          >Readings for the session</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: [
    "topic",
    "yt",
    "zm",
    "readings",
    "project",
    "materials",
    "req",
    "end_date",
    "statusx",
    "soln",
  ],
  data: () => ({}),
  methods: {
    linkOpen(mylink) {
      window.open(mylink, "_blank");
    },
  },
};
</script>

<style>
</style>